import './Header.css';
import {
  IonHeader,
  IonToolbar,
  IonImg,
  IonButtons,
  IonButton,
  IonIcon,
} from '@ionic/react';
import { useContext } from 'react';
import { AppContext } from '../../state/AppContextProvider';
import { DebugLink, useDebugLink } from '../../hooks/DebugHooks';

interface HeaderProps {}

type Logo = {
  src: string;
  alt: string;
};
const logo: Logo = {
  src: '/assets/logo/logoPortail.svg',
  alt: 'Logo CIUP',
};

const Header: React.FC<HeaderProps> = () => {
  const { state } = useContext(AppContext);

  const { incTouchCount } = useDebugLink();

  if (state.isConnected) {
    return (
      <IonHeader className="flex flex-row items-center top-0 h-24 shadow-none p-4 bg-white md:absolute md:w-64 md:justify-center md:px-7">
        <IonToolbar>
          <DebugLink />
          <IonImg
            slot="start"
            className="logo md:text-center md:mx-auto md:block md:w-11/12"
            alt={logo.alt}
            src={logo.src}
            onClick={incTouchCount}
          />

          <IonButtons slot="end" className="md:hidden">
            <IonButton routerLink="/my-identity/identification">
              <IonIcon
                slot="icon-only"
                className="stroke-black text-black"
                src="./assets/nav/card.svg"
              />
            </IonButton>
            <IonButton routerLink="/pages/map">
              <IonIcon
                slot="icon-only"
                className="stroke-black"
                src="./assets/nav/compass.svg"
              />
            </IonButton>
            <IonButton routerLink="/directory">
              <IonIcon
                slot="icon-only"
                className="stroke-black"
                src="/assets/nav/directory.svg"
              />
            </IonButton>

            <IonButton routerLink="/search">
              <IonIcon
                slot="icon-only"
                className="stroke-black"
                src="/assets/nav/search.svg"
              />
            </IonButton>
          </IonButtons>
        </IonToolbar>
      </IonHeader>
    );
  } else {
    return <IonHeader className="hidden"></IonHeader>;
  }
};

export default Header;
